import { NavLink } from 'react-router-dom';

interface Props {
  icon: any;
  label: string;
  path: string;
  disabled?: boolean;
}

const SidebarMenuItem = ({ icon: Icon, label, path, disabled }: Props) => {
  if (disabled) {
    return (
      <div
        className="
          flex
          items-center
          gap-3
          px-4
          py-3
          text-gray-400
          cursor-not-allowed
        "
      >
        <Icon size={18} />

        <span className="text-sm">{label}</span>
      </div>
    );
  }

  return (
    <NavLink
      to={path}
      className={({ isActive }) =>
        `
    flex
    items-center
    gap-4
    px-5
    py-4
    rounded-2xl
    transition-all
    duration-300
    ${
      isActive
        ? `
          bg-gradient-to-r
          from-[#0E7490]
          to-[#14B8A6]
          text-white
          shadow-[0_0_20px_rgba(20,184,166,0.45)]
        `
        : `
          text-[#E5EDF2]
          hover:bg-gradient-to-r
          hover:from-[#0E7490]
          hover:to-[#14B8A6]
          hover:text-white
          hover:shadow-[0_0_20px_rgba(20,184,166,0.45)]
          hover:scale-[1.02]
        `
    }
  `
      }
    >
      <Icon size={20} strokeWidth={1.8} />

      <span className="text-[15px] font-medium">{label}</span>
    </NavLink>
  );
};

export default SidebarMenuItem;
